export function appendOrReplaceNodeById<T extends { id: string }>(
  nodes: readonly T[],
  node: T,
): T[] {
  const index = nodes.findIndex((existing) => existing.id === node.id)
  if (index === -1) {
    return [...nodes, node]
  }

  const updated = [...nodes]
  updated[index] = node
  return updated
}
